import React from 'react';
import BuzzInput from '../BuzzInput/BuzzInput';
import { IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

function BuzzPassword({ label, value, placeholder, onChange }) {
  const [showPassword, setShowPassword] = React.useState(false);
  return (
    <BuzzInput
      label={label}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <IconButton
            type="checkbox"
            aria-label="toggle password visibility"
            value={showPassword}
            onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        ),
      }}
    />
  );
}

export default BuzzPassword;
